/**
 * Versionado de documentos legales.
 *
 * IMPORTANTE: incrementar la versión correspondiente cada vez que
 * cambie sustancialmente el contenido de los Términos o la Política
 * de Privacidad. Este número se almacena junto al consentimiento
 * del usuario para evidencia de aceptación (auditoría legal).
 */
export const TERMS_VERSION = "1.0.0";
export const PRIVACY_VERSION = "1.0.0";
export const LEGAL_LAST_UPDATED = "2026-04-23";

export const ORG_INFO = {
  developer: "dlsoft.dev",
  developerUrl: "https://dlsoft.dev",
  client:
    "Asociación del Oriente Colombiano - Iglesia Adventista del Séptimo Día",
  clientShort: "Asociación del Oriente Colombiano",
  product: "Insignia7",
  productUrl: "https://insignia7.com",
  contactEmail: "soporte@insignia7.com",
  privacyEmail: "privacidad@insignia7.com",
  jurisdiction: "República de Colombia",
} as const;
